import Image from "@widgets/image/image";
import { useA11yContext } from "@assets/spa/context/a11y";
import { useI18n } from "@wordpress/react-i18n";
import React from "react";
export default function EventsTop({ map, date, time, image, title, is_paid, price }) {
    const [state] = useA11yContext();
    const has_image = (image === null || image === void 0 ? void 0 : image.url) && (state === null || state === void 0 ? void 0 : state.illustrations) === true;
    const { __ } = useI18n();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "ltg-post-top ltg-post-top-responsive-tablet ltg-post-top--events" },
            has_image && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "ltg-post-top-col" },
                    React.createElement("div", { className: `ltg-post-top-img-wrap` }, (image === null || image === void 0 ? void 0 : image.url) && React.createElement(Image, { image: image, mask: "rounded" }))))),
            React.createElement("div", { className: "ltg-post-top-col" },
                React.createElement("div", { className: "ltg-post-top-card" },
                    React.createElement("div", null,
                        React.createElement("h2", { className: "ltg-post-top-title" }, title),
                        React.createElement("p", { className: "ltg-post-top-date" },
                            React.createElement("i", { className: "fas fa-calendar-alt text-primary" }),
                            " ",
                            date,
                            " ",
                            time ? time.substring(0, 5) : ''),
                        React.createElement("div", { className: "ltg-post-top-price" }, is_paid === '1' ? `${price} €` : __('Nemokamas', 'ltg-widgets')),
                        map && (map === null || map === void 0 ? void 0 : map.markers.map(({ label, uuid }) => React.createElement("div", { key: uuid, className: "ltg-post-top-address" },
                            React.createElement("i", { className: "fas fa-map-marker-alt text-primary" }),
                            label)))))))));
}
